<div id="login">
	<div class="img" *ngIf="this.photo" [ngStyle]="{'background-image': 'url(' + photo.photo +')'}">
	</div>
	<div class="form">

		<div class="heading temp">
			<div>Sign In</div>
			<!--<div class="logo"><img src="../../../../../assets/images/promaster_logo.png"></div>-->
			<div class="logo-temp">PRO Connection</div>
		</div>

		<div class="field">

			<label for="username">Username</label>

			<input pInputText [(ngModel)]="username" id="username" placeholder="Input your username here" (keydown.enter)="login()">

		</div>

		<div class="field">
			<label for="password">Password</label>
			<p-password [toggleMask]="true" [(ngModel)]="password" id="password" placeholder="Input your password here" [feedback]="false"  (keydown.enter)="login()"></p-password>
			<div class="forgot-link"><a [routerLink]="['/forgot-password']">Forgot password?</a></div>
		</div>

		<div class="field">
			<button (click)="login()">Log In</button>
		</div>
	</div>
	<!--<div class="credit" style="display: none;">-->

	<div class="credit" *ngIf="photo">
		<!--<	Photo credit:  {{photo.photographer}}-->
	


		<div *ngFor="let item of photo.photographer.split('|') ; let i = index">

			<div *ngIf="i === 0" class="CreditName">
				Photo credit: {{ item }}
				<div class="email">
					<a href="mailto:ConnectionPhotos@promaster.com?subject=Suggested Photo" target="_blank"> Submit a Photo </a>
				</div>
			</div>

		
			<div class="social">
				<!--You Tube-->
				<div class="social1">
					<div *ngIf="i === 1 && item.length > 5">
						<a href="{{item}}" target="_blank"><img src='../../../../../assets/images/Y.png' width="50" height="50"> </a>
					</div>
				</div>
				<!-- FB -->
				<div class="social2">
					<div *ngIf="i === 2 && item.length > 5 ">
						<a href="{{item}}" target="_blank">	<img src='../../../../../assets/images/F.png' width="50" height="50"> </a>
					</div>
				</div>
				<!-- Insta  -->
				<div class="social3">
					<div *ngIf="i === 3 && item.length > 5" class="social3">
						<a href="{{item}}" target="_blank">	<img src='../../../../../assets/images/I.png' width="50" height="50"></a>
					</div>
					</div>
				</div>

			</div>

		

			<div [innerHTML]="photoBlock"></div>
		</div>
	</div>





